import { render, staticRenderFns } from "./_SegmentControl.vue?vue&type=template&id=6a64a014"
import script from "./_SegmentControl.vue?vue&type=script&lang=js"
export * from "./_SegmentControl.vue?vue&type=script&lang=js"
import style0 from "./_SegmentControl.vue?vue&type=style&index=0&id=6a64a014&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports